var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBnbIconLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_1751_4096)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9,
    fill: "#F3BA2F",
    fillOpacity: 0.12
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.66966 9.0416L9.99978 6.71148L12.3319 9.04359L13.6876 7.68785L9.99978 4L6.31392 7.68586L7.66966 9.0416ZM4 9.9996L5.35539 8.64421L6.71077 9.9996L5.35539 11.355L4 9.9996ZM9.99964 13.2885L7.66953 10.9584L6.31179 12.3122L6.31379 12.3141L9.99964 16L13.6875 12.3122L12.3318 10.9564L9.99964 13.2885ZM13.2876 10.0004L14.643 8.64501L15.9984 10.0004L14.643 11.3558L13.2876 10.0004ZM9.99982 8.62425L11.3755 9.99995L9.99982 11.3777L8.62411 10.0019V9.99796L8.86571 9.75636L8.98351 9.64055L9.99982 8.62425Z",
    fill: "#F3BA2F"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1751_4096",
    x: -37,
    y: -37,
    width: 94,
    height: 94,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 19
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1751_4096"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1751_4096",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBnbIconLight);
export default __webpack_public_path__ + "static/media/bnbIcon_light.263abe11c5676a01655ac931c3c2748e.svg";
export { ForwardRef as ReactComponent };